import { render } from "./DeclaracoesDocumentos.vue?vue&type=template&id=f0c402b0"
import script from "./DeclaracoesDocumentos.vue?vue&type=script&lang=js"
export * from "./DeclaracoesDocumentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__